import React, { Component, PropTypes } from 'react';
import {
  NitroButtonGroup,
  NitroButton
} from 'nitro-components';

import { find } from 'lodash';

import { connect } from 'react-redux';

import SingleSelect from '../single-select/SingleSelect';

import Filter from '../Filter';
class BusinessEntityFilter extends Filter {

  static getLabel(filter) {
    super.getLabel(filter);
  }

  render() {

    const {filter, action,businessEntitiesDataSource} = this.props;
    
    const options = (businessEntitiesDataSource||[]).map(entity => ({
      label: `${entity.Description}`,
      value: entity.Id,
      entity
    }));

    const newFilter = {...filter, options};

    return (
      <SingleSelect action={action} filter={newFilter} />
    );
  }


}


BusinessEntityFilter.propTypes = {
  action: PropTypes.func,
  filter: PropTypes.object.isRequired,
  businessEntitiesDataSource: PropTypes.array
};


const mapStateToProps = (state) => {
  
  return {
    
  };

};


export default connect(mapStateToProps, null)(BusinessEntityFilter);



// WEBPACK FOOTER //
// ./src/components/filter/filters/business-entity/BusinessEntity.js